/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListEnd = [
  ["path", { d: "M16 5H3" }],
  ["path", { d: "M16 12H3" }],
  ["path", { d: "M9 19H3" }],
  ["path", { d: "m16 16-3 3 3 3" }],
  ["path", { d: "M21 5v12a2 2 0 0 1-2 2h-6" }]
];

export { ListEnd as default };
//# sourceMappingURL=list-end.js.map
